export const MAX_PROFILE_IMAGE_BYTES = 5 * 1024 * 1024;
export const nicknameCharacters = (value) => Array.from(String(value).normalize('NFC'));
export const limitNickname = (value) => nicknameCharacters(value).slice(0, 14).join('');
export const validNickname = (value) => {
  const s = value.normalize('NFC').trim();
  return (
    nicknameCharacters(s).length >= 2 &&
    nicknameCharacters(s).length <= 14 &&
    /^[가-힣a-zA-Z0-9\s]+$/.test(s)
  );
};
export const profileDraft = (user) => ({
  nickname: user.nickname || '',
  bio: user.bio || '',
  profileImageUrl: user.profileImageUrl ?? null,
  profileBackgroundImageUrl: user.profileBackgroundImageUrl ?? null,
});
export const profilePayload = (draft, original) => ({
  ...draft,
  nickname: draft.nickname.normalize('NFC').trim(),
  isProfileImageChanged: draft.profileImageUrl !== original.profileImageUrl,
  isProfileBackgroundImageChanged:
    draft.profileBackgroundImageUrl !== original.profileBackgroundImageUrl,
});
export function profileCropRect(width, height, ratio = 1, x = 0.5, y = 0.5, zoom = 1) {
  if (!(width > 0 && height > 0 && ratio > 0)) throw Error('Invalid image');
  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
  const w = Math.min(width, height * ratio) / clamp(zoom, 1, 3),
    h = w / ratio;
  return { x: (width - w) * clamp(x, 0, 1), y: (height - h) * clamp(y, 0, 1), width: w, height: h };
}
export async function exportProfileImage(image, ratio, position) {
  const r = profileCropRect(image.naturalWidth, image.naturalHeight, ratio, ...position);
  const canvas = document.createElement('canvas');
  canvas.width = Math.min(1600, Math.max(1, Math.round(r.width)));
  canvas.height = Math.max(1, Math.round(canvas.width / ratio));
  const c = canvas.getContext('2d');
  if (!c) throw Error('Image editing unavailable');
  c.fillStyle = '#fff';
  c.fillRect(0, 0, canvas.width, canvas.height);
  c.drawImage(image, r.x, r.y, r.width, r.height, 0, 0, canvas.width, canvas.height);
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.82));
  if (!blob || blob.size > MAX_PROFILE_IMAGE_BYTES) throw Error('Image export failed');
  return new File([blob], 'profile.jpg', { type: 'image/jpeg' });
}
